import uniq from 'lodash-es/uniq';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { FetchOpenOrders, IOpenOrdersResponse, orderActionCreators, OrderActionKeys } from '..';
import { IState } from '../..';
import { getDefaultSalesDistricts } from '../../auth';
import { FilterTypes, getFilters, ISalesDashboardFilters } from '../../filters';
import { getRegionSalesDistricts } from '../../lookups/lookupsSelectors';
import * as api from '../orderApi';

function* fetchOpenOrders(action: FetchOpenOrders) {
  let sds: string[] = yield select(getDefaultSalesDistricts);

  const filters: ISalesDashboardFilters = yield select((state: IState) =>
    getFilters(state, FilterTypes.salesDashboard)
  );

  if (filters.salesDistricts.length > 0 || filters.regions.length > 0) {
    const regionSds = yield select((state: IState) => getRegionSalesDistricts(state, filters.regions));
    sds = uniq([...filters.salesDistricts, ...regionSds]);
  }

  const openOrders: IOpenOrdersResponse = yield call(api.fetchOpenOrders, action.payload, sds, filters.companies);

  if (openOrders) {
    yield put(orderActionCreators.setOpenOrders({ request: action.payload, response: openOrders }));
  }
}

export function* watchFetchOpenOrders() {
  yield takeEvery(OrderActionKeys.FETCH_OPEN_ORDERS, fetchOpenOrders);
}
